import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import icons from 'assets/icons'
import Spinner from 'components/loader/Spinner'
import React, { useState, useEffect } from 'react'
import Button from 'components/formElements/Button'
import PropTypes from 'prop-types'
import useWindowSize from 'hooks/useWindowSize'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { TabView, TabPanel } from 'primereact/tabview'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { Calendar } from 'primereact/calendar'
import { InputTextarea } from 'primereact/inputtextarea'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { getPermission } from 'utils/Auth'
import { useDispatch, useSelector } from 'react-redux'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import {calculateIzinGun, leaveDayPeriod} from 'utils/Constants'
import {useFileReader} from 'hooks/useFileReader'
import Icons from 'assets/icons'
import {Checkbox} from 'primereact/checkbox'

const Developers = () => {
	const initialDeveloperState = { open: false, developer: {}, isEdit: false }
	const initialLeave = {
		"forWhomUserId": "",
		"startDate": "",
		"endDate": "",
		"startDayPeriod": leaveDayPeriod[0].value,
        "endDayPeriod": leaveDayPeriod[0].value,
		"leaveTypeId": "",
		"description": null,
		"leaveText": "",
		"isReduceLeave": 0
	}
	const [filterOptions, setFilterOptions] = useState({ showLayoffs: false, searchString: '',inOutSource:'', developerSkills: [], department: [] })
	const { width } = useWindowSize()
	const [request] = useRequest()
	const { showToast } = useToast()
	const [getDevelopers, getDevelopersLoading] = useRequest()
	const dispatch = useDispatch()
	const { general } = useSelector((state) => state)
	const { approvalModal } = general
	const [skills, setSkills] = useState([])
	const [departments, setDepartments] = useState([])
	const [developers, setDevelopers] = useState([])
	const [createDev, setCreateDev] = useState()
	const [evalDev, setEvalDev] = useState(false)
	const [addMeetNoteModal, setAddMeetNoteModal] = useState(false)
	const [addLeaveModal, setAddLeaveModal] = useState(false)
	const [evalNotes, setEvalNotes] = useState([])
	const [isEvalEdit, setIsEvalEdit] = useState(false)
	const [editDeveloper, setEditDeveloper] = useState(initialDeveloperState)
	const [activeIndex, setActiveIndex] = useState(0)
	const [leaveTypes, setLeaveTypes] = useState([])
	const[leave, setLeave] = useState(initialLeave)
	const[leaves, setLeaves] = useState([])
	const [developerById, setDeveloperById] = useState({})
    const [leaveDayPeriodList, setLeaveDayPeriodList] = useState([])
	const [leavesLoading, setLeavesLoading] = useState(false)
	const [hrUsers, setHrUsers] = useState([])
	const [companies, setCompanies] = useState([])
	const [addDevForm, setAddDevForm] = useState({
		fullName: '',
		startDate: null,
		endDate: null,
		developerSkills: [],
		jiraUserId: '',
		email: '',
		departmentId: [],
		hrId: [],
		inOutSource:null,
		companyId:null
	})


	console.log(departments, "department")
	const [evalDevForm, setEvalDevForm] = useState({
		description: '',
		meetDate: new Date(),
		motivationPoint: 0,
	})
	useEffect(() => {
		if (evalDev) {
			setEvalDevForm({
				description: '',
				meetDate: new Date(),
				motivationPoint: 0,
			})
		}
	}, [evalDev])
	useEffect(() => {
		if (editDeveloper.open) {
			setLeaveDayPeriodList(leaveDayPeriod.map((pt) => ({ label: pt?.type, value: pt.value })))
			setAddDevForm({
				id: editDeveloper.developer.id,
				fullName: editDeveloper.developer.fullName,
				startDate: editDeveloper.developer.startDate,
				endDate: editDeveloper.developer.endDate,
				lastMeetDate: editDeveloper.developer.lastMeetDate,
				developerSkills: editDeveloper.developer.developerSkills,
				jiraUserId: editDeveloper.developer.jiraUserId,
				email: editDeveloper.developer.email,
				hrId: editDeveloper.developer.hrId,
				departmentId: editDeveloper.developer.department,
				companyId: editDeveloper.developer.companyId,
				inOutSource: editDeveloper.developer.inOutSource,
			})
			console.log(editDeveloper, "sdfasdf")
			if (editDeveloper.isEdit) {
				getDevelopers('/DeveloperEval/GetAllEvals', {
					method: 'GET',
					params: {
						developerId: editDeveloper.developer.id,
					},
				}).then((res) => {
					setEvalNotes(res.data.result)
				})
			}
		} else if (!editDeveloper.open) {
			getDevelopers('/Developer/GetAllDevelopers', {
				method: 'GET',
				params: {
					showLayoffs: filterOptions.showLayoffs,
				},
			}).then((res) => {
				if (res.data.ok) {
					setDevelopers(res.data.result)

				}
			})
		}
	}, [editDeveloper])

	const handleCloseModal = () => {
		setEditDeveloper(initialDeveloperState),
			setCreateDev()
			setActiveIndex(0)
			setLeaves([])
			setDeveloperById({})
		setFilterOptions({ searchString: '' })
	}
	const handleCloseLeaveModal = () => {
		setAddLeaveModal(false)
		setLeave(initialLeave)
		setFilesData([])
	}
	useEffect(() => {
		if (createDev) {
			setAddDevForm({
				fullName: '',
				skillsText: '',
				startDate: null,
				endDate: null,
				developerSkills: [],
				jiraUserId: '',
				email: '',
				hrId: '',
				departmentId: '',
				companyId:'',
			})
		} else if (!createDev) {
			getDevelopers('/Developer/GetAllDevelopers', {
				method: 'GET',
				params: {
					showLayoffs: filterOptions.showLayoffs,
				},
			}).then((res) => {
				setDevelopers(res.data.result)


				request('/Developer/GetDepartments', {
					method: 'GET',
				}).then((res) => {
					if (res.data.ok) {
						setDepartments(res.data.result.map((s) => ({ label: s.name, value: s.id })))
					}
				})
			})
			getDevelopers('/Developer/GetDeveloperSkills', { method: 'GET' }).then((res) => {
				setSkills(res.data.result.map((s) => ({ label: s.name, value: s.id })))
			})
			getDevelopers('/Developer/GetCompanies', { method: 'GET' }).then((res) => {
				setCompanies(res.data.result.map((s) => ({ label: s.name, value: s.id })))
			})
		}
	}, [createDev])

	const createDevFunc = () => {
		setCreateDev(true)
	}
	// const handleRatingChange = (event) => {
	// 	setRating(event.value)
	// }
	const [filesData, setFilesData, convert] = useFileReader()
	console.log(filesData,'filesData')
	const handleFiles = (e) => {
		convert(e.files)
	}
	const removeFile = (file) => {
		setFilesData((prev) => [...prev.filter((f) => f.fileName !== file.fileName)])
	}
	const handleDeleteRow = (deleteData, deleteEndpoint, datatable) => {
		dispatch(openApprovalModal({ open: true, content: 'Silmek istediğinize emin misiniz?', deleteData, deleteEndpoint, datatable }))
	}
	const handleSubmitApproval = () => {
		request(approvalModal.deleteEndpoint, {
			method: 'DELETE',
			data: { id: approvalModal.deleteData.id },
		}).then(async (res) => {
			if (!res.data.metadata) {
				if (approvalModal.datatable == 'notesTable') {
					showToast('Not Silindi', 'success')
					getDevelopers('/Developer/GetDeveloperById', {
						method: 'GET',
						params: {
							id: editDeveloper.developer.id,
						},
					}).then((res) => {
						setAddDevForm({
							...addDevForm,
							...res.data.result,
							developerSkills: res.data.result.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
						})
						getDevelopers('/DeveloperEval/GetAllEvals', {
							method: 'GET',
							params: {
								developerId: editDeveloper.developer.id,
							},
						}).then((res) => {
							setEvalNotes(res.data.result)
							handleCloseApprovalModal()
						})
					})
				}
				if (approvalModal.datatable == 'developers') {
					showToast('Geliştirici Silindi', 'success')
					getDevelopers('/Developer/GetAllDevelopers', {
						method: 'GET',
						params: {
							showLayoffs: filterOptions.showLayoffs,
						},
					}).then((res) => {
						if (res.data.ok) {
							setDevelopers(res.data.result)
							handleCloseApprovalModal()
						}
					})
				}
				if (approvalModal.datatable == 'leaves') {
					setLeavesLoading(true)
					request('/Developer/GetDeveloperById', {
						method:'GET',
						params:{
							id:addDevForm.id
						}
					}).then(res =>{
						showToast('İzin Kaydı Silindi', 'success')
						setLeavesLoading(false)
						setDeveloperById(res?.data?.result)
						setLeaves(res?.data?.result?.leaves?.length > 0 ? res?.data?.result?.leaves.map(l => ({
							...l,
							totaleave:calculateIzinGun(l.startDate, l.endDate, l.startDayPeriod, l.endDayPeriod)
						})) : [])
						handleCloseApprovalModal()
					})
				}
			} else if (res?.data?.metadata?.message) {
				if (approvalModal.datatable == 'leaves') {
					showToast('Kayıt Silinemedi', 'error')
				} else {
					showToast('Kayıt Silinemedi Kullanıcıya Ait Not Bilgisi Olmadığından Emin Olun.', 'error')
				}
			}
		})
	}
	console.log(developerById,'devvvv')
	const handleCloseApprovalModal = async () => {
		dispatch(closeApprovalModal())
	}
	const handleChange = (e, name) => {
		if (name) {
			setAddDevForm((prev) => ({ ...prev, [name]: e }))
		} else {
			setAddDevForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}

	const handleShowLayoffs = (e) => {
		setFilterOptions((prev) => ({ ...prev, ['showLayoffs']: e.value }))
	}
	const handleinOutSource = (e) => {
		setFilterOptions((prev) => ({ ...prev, ['inOutSource']: e.value }))
	}

	const handleSkills = (e) => {
		setFilterOptions((prev) => ({
			...prev,
			['developerSkills']: e && e != undefined ? e : e.length > 0 && e,
		}))
	}
	const handleDepartment = (e) => {
		setFilterOptions((prev) => ({
			...prev,
			['department']: e && e != undefined ? e : e.length > 0 && e,
		}))
		// setFilterOptions((prev) => ({ ...prev, ['department']: e }))
	}

	const handleChangeEval = (e) => {
		setEvalDevForm((prev) => ({ ...prev, [e.name]: e.value }))
	}

	useEffect(() => {
		getDevelopers('/Developer/GetAllDevelopers', {
			method: 'GET',
			params: {
				showLayoffs: filterOptions.showLayoffs,
			},
		}).then((res) => {
			if (res.data.ok) {
				setDevelopers(res.data.result)
			}
		})
		getDevelopers('/Developer/GetAllHR', { method: 'GET' }).then((res) => {
			setHrUsers(res.data.result.map(h => ({label:h.fullName,value:h.id})))
		})
	}, [filterOptions.showLayoffs])


	const handleChnage = (e, name, array) => {
		if (name == 'showLayoffs') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [e.name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[e.name]: e.value && e.value != undefined ? e.value : '',
				}))
			}
		}
	}

	const handleSubmit = async () => {
		if (!addDevForm.fullName) {
			showToast('Geliştirici Adını Giriniz', 'error')
		} else if (!addDevForm.developerSkills) {
			showToast('Geliştirici Kabiliyeti Giriniz', 'error')
		} else if (addDevForm?.inOutSource == null) {
			showToast('Geliştirici Çalışma Şeklini Seçiniz', 'error')
		} else if (!addDevForm?.departmentId) {
			showToast('Geliştirici Departmanını Seçiniz', 'error')
		} else if (!addDevForm?.companyId) {
			showToast('Geliştirici Şirketi Seçiniz', 'error')
		} else if (!addDevForm.startDate) {
			showToast('İşe Başlama Tarihi Giriniz', 'error')
		} else {
			getDevelopers('/Developer/UpsertDeveloper', {
				method: 'POST',
				data: {
					...addDevForm,
					developerSkills: addDevForm.developerSkills.map((s) => s.value),
					// inOutSource can be either {label, value} (after select change)
					// or numeric (when untouched in edit mode), so normalize before submit.
					inOutSource: addDevForm?.inOutSource?.value ?? addDevForm?.inOutSource,
					departmentId: editDeveloper?.open
						? addDevForm?.departmentId?.id ? addDevForm?.departmentId?.id : addDevForm?.departmentId?.value : addDevForm.departmentId.value,
					hrId: editDeveloper?.open
						? !addDevForm?.hrId?.value ? addDevForm?.hrId : addDevForm?.hrId?.value : addDevForm.hrId.value,
					companyId: editDeveloper?.open
						? !addDevForm?.companyId?.value ? addDevForm?.companyId : addDevForm?.companyId?.value : addDevForm.companyId.value,
				},
			}).then((res) => {
				if (res.data) {
					if (res.data.ok) {
						if (editDeveloper.open == true) {
							showToast('Geliştirici Düzenlendi', 'success')
							setEditDeveloper(initialDeveloperState)
						}
						if (createDev == true) {
							showToast('Geliştirici Eklendi', 'success')
							setCreateDev()
						}
					}
				}
			})
		}
	}
	console.log(hrUsers,'hrUsers')
	const handleSubmitLeave = (developer) => {
		if (!leave.leaveTypeId || !leave.startDate || !leave.endDate) {
			showToast('Lütfen İzin Türü, İzin Başlangıç ve Bitiş Tarihi Alanlarını Doldurun', 'error')
			return
		}
		if (leave?.id) {
			request('/DeveloperLeave/UpsertLeave', {
                method: 'POST',
                data: {
					"forWhomUserId": leave.forWhomUserId,
					"startDate": leave.startDate,
					"endDate": leave.endDate,
					"startDayPeriod": leave.startDayPeriod,
					"endDayPeriod": leave.endDayPeriod,
					"leaveTypeId": leave.leaveTypeId,
					"description": null,
					"leaveText": leave.leaveText,
					"id": leave.id,
					"isReduceLeave": leave.isReduceLeave
				},
            }).then(res2 => {
				if (res2.data.ok) {
					showToast('İzin Bilgisi Güncellendi', 'success')
				}
				handleCloseLeaveModal()
				request('/Developer/GetDeveloperById', {
					method:'GET',
					params:{
						id:addDevForm.id
					}
				}).then(res =>{
					setAddLeaveModal(false)
					setDeveloperById(res?.data?.result)
					setLeaves(res?.data?.result?.leaves?.length > 0 ? res?.data?.result?.leaves?.map(l => ({
						...l,
						totaleave:calculateIzinGun(l.startDate, l.endDate, l.startDayPeriod, l.endDayPeriod)
					})): [])
				})
			})
		}
		else {
			const formDatas = new FormData()
			if (filesData.length > 0) {
				filesData.forEach(f => {
					formDatas.append('Documents', f.file)
				})
			}
			formDatas.append('ForWhomUserId', developer.id)
			formDatas.append('StartDate', leave.startDate)
			formDatas.append('EndDate', leave.endDate)
			formDatas.append('StartDayPeriod', leave.startDayPeriod)
			formDatas.append('EndDayPeriod', leave.endDayPeriod)
			formDatas.append('LeaveTypeId', leave.leaveTypeId)
			if (addDevForm.leaveText) {
				formDatas.append('LeaveText', addDevForm.leaveText)
			}
			formDatas.append('IsReduceLeave', leave.isReduceLeave)
			request('/DeveloperLeave/AddLeave', {
				method:'POST',
				data:formDatas
			}).then(res2 => {
				if (res2.data.ok) {
					showToast('İzin Bilgisi Eklendi', 'success')
				}
				handleCloseLeaveModal()
				request('/Developer/GetDeveloperById', {
					method:'GET',
					params:{
						id:addDevForm.id
					}
				}).then(res =>{
					setAddLeaveModal(false)
					setDeveloperById(res?.data?.result)
					setLeaves(res?.data?.result?.leaves?.length > 0 ? res?.data?.result?.leaves?.map(l => ({
						...l,
						totaleave:calculateIzinGun(l.startDate, l.endDate, l.startDayPeriod, l.endDayPeriod)
					})): [])
				})
			})
		}
		

		console.log(leave,'leave')
	}
	console.log(leave,'leave')
	const handleChnageLeave = (e, name) => {
		if (name) {
			setLeave((prev) => ({ ...prev, [name]: e }))
		} else {
			setLeave((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}
	console.log(addDevForm, 'addDev Form')
	const handleEval = async (isEdit) => {

		setEvalDevForm({
			description: '',
			meetDate: new Date(),
		})
		if (!evalDevForm.meetDate) {
			showToast('Görüşme Tarihini Giriniz', 'error')
		} else if (!evalDevForm.description) {
			showToast('Görüşme Notu Giriniz', 'error')
		} else {
			getDevelopers('/DeveloperEval/UpsertEval', {
				method: 'POST',
				data: {
					...evalDevForm,
					forWhomUserId: addDevForm.id,
				},
			}).then((res) => {
				if (res.data) {
					if (res.data.ok) {
						getDevelopers('/DeveloperEval/GetAllEvals', {
							method: 'GET',
							params: {
								developerId: editDeveloper.developer.id,
							},
						}).then((res) => {
							setEvalNotes(res.data.result)
						})
						getDevelopers('/Developer/GetDeveloperById', {
							method: 'GET',
							params: {
								id: editDeveloper.developer.id,
							},
						}).then((res) => {
							setAddDevForm({
								...addDevForm,
								...res.data.result,
								developerSkills: res.data.result.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
							})
						})
						setEvalDevForm({
							description: '',
							meetDate: new Date(),
							motivationPoint: 0,
						})
						showToast('Geliştirici Notu Eklendi', 'success')
						setAddMeetNoteModal(false)
						if (isEdit) {
							setIsEvalEdit(false)
						} else {
							setEvalDev(false)
						}
						// setEditDeveloper()
					}
				}
			})
		}
	}
	const evalDevFunc = () => {
		setEvalDev(true)
	}
	console.log(leaves, 'leaves')
	const handleEditClick = (rowData) => {
		setIsEvalEdit(true)
		setEvalDevForm({
			id: rowData.id,
			description: rowData?.description,
			meetDate: rowData?.meetDate || new Date(),
			motivationPoint: rowData?.motivationPoint,
		})
	}
	const filteredDevs = developers.filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k] != null) {
					if (k == 'searchString') {
						rt.push(d.fullName.toLowerCase().match(filterOptions[k].toLowerCase()))
					} else if (k == 'inOutSource') {
						rt.push(d.inOutSource == filterOptions[k] )
					} else if (k == 'showLayoffs') {
						rt.push(true)
					} else if (k == 'developerSkills') {
						filterOptions.developerSkills.length > 0 &&

							rt.push(d.skillsText.split(',').some(r => filterOptions[k].map((e) => e.label).indexOf(r) >= 0))
					} else if (k == 'department') {

						filterOptions?.department?.length > 0 &&
							rt.push(d?.department?.name.split(',').some(r => filterOptions[k].map((e) => e.label).indexOf(r) >= 0))

						// rt.push(d.department.name == (filterOptions[k].map((e) => e.label)))
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	let maxDate = new Date()
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getDevelopersLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<DataTable
					stripedRows
					className='col-md-12 p-1'
					emptyMessage='Hiç Kayıt Bulunamadı'
					size='small'
					responsiveLayout='stack'
					dataKey='id'
					header={() => (
						<div className='d-flex justify-content-between gap-3'>
							<div className='row flex-1'>
								<div className='col-md-4 pl-0'>
									<span className='p-input-icon-left w-100 '>
										<i className='pi pi-search' />
										{filterOptions.searchString && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
										<input
											className='default-input pl-5 pr-4'
											type='text'
											value={filterOptions.searchString}
											name='searchString'
											onChange={(e) => handleChnage(e.target)}
											placeholder={'Arama Yapın...'}
										/>
									</span>
								</div>

								<div className='col-md-2'>
									<DefaultSelect
										name='ShowLayoffs'
										handleChange={(e) => handleShowLayoffs(e)}
										placeholder='Çalışma Durumu'
										value={[
											{ label: 'Aktif Çalışanlar', value: false },
											{ label: 'İşten Ayrılanlar', value: true },
										].find((f) => f.value == filterOptions.showLayoffs)}
										selectOptions={[
											{ label: 'Aktif Çalışanlar', value: false },
											{ label: 'İşten Ayrılanlar', value: true },
										]}
									// defaultValue={false}
									/>
								</div>
								<div className='col-md-2'>
									<DefaultSelect
										name='inOutSource'
										handleChange={(e) => handleinOutSource(e)}
										placeholder='Çalışma Tipi'
										value={[
											{ label: 'In-House', value: 0 },
											{ label: 'Outsource', value: 1 },
										].find((f) => f.value == filterOptions.inOutSource)}
										selectOptions={[
											{ label: 'In-House', value: 0 },
											{ label: 'Outsource', value: 1 },
										]}
									// defaultValue={false}
									/>
								</div>
								<div className='col-md-2'>
									<DefaultSelect
										isMulti={true}
										name='developerSkills'
										placeholder='Kabiliyetler'
										value={filterOptions.developerSkills}
										selectOptions={skills}
										handleChange={(e) => handleSkills(e, 'developerSkills')}

									/>
								</div>
								<div className='col-md-2'>
									<DefaultSelect
										isMulti={true}
										name='department'
										placeholder='Departmanlar'
										value={filterOptions.deparment}
										selectOptions={departments}
										handleChange={(e) => handleDepartment(e, 'department')}

									/>
								</div>
							</div>
							<div className='filters-right'>
								{getPermission('Developer.create') && (
									<Button
										handleClick={() => createDevFunc()}
										className='btn-success'
										title={width <= 936 ? '' : 'Çalışan Ekle'}
										icon={<icons.plus />}
									/>
								)}
							</div>
						</div>
					)}
					rowClassName={`cursor-pointer table-hover `}
					value={filteredDevs}
				>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						style={{ width: 'auto', position: 'relative' }}
						field='fullName'
						header='Adı Soyadı'
						sortable='true'
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}}
									className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData.fullName && `${rowData.fullName}`} {rowData.name}
								</div>
							)
						}}
					/>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						style={{ width: 'auto', position: 'relative' }}
						field='email'
						header='Email Adresi'
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}} className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData.email && `${rowData.email}`} {rowData.name}
								</div>
							)
						}}
					/>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						style={{ width: 'auto', position: 'relative' }}
						field='skillsText'
						header='Kabiliyetler'
						selectOptions={skills?.map((pt) => ({ label: pt.name, value: pt.id }))}
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}} className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData.skillsText && `${rowData.skillsText}`} {rowData.name}
								</div>
							)
						}}
					/>
					<Column
						field='startDate'
						header='İşe Giriş Tarihi'
						sortable='true'
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60
							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}} className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData.startDate && <span> {moment(rowData.startDate).format('LL')}</span>}
								</div>
							)
						}}
					/>
					<Column
						field='lastMeetDate'
						header='Son Görüşme Tarihi'
						sortable='true'
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

							return (
								<span onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}}
									className={`projects-list-card-footer-period cellSetTransparent text-sm ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'
										}`}
								>
									{rowData.lastMeetDate && <span> {moment(rowData.lastMeetDate).format('LL')}</span>}
								</span>
							)
						}}
					/>
					<Column
						field='company'
						header='Şirket'

						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}} className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData?.company?.name}
								</div>
							)
						}}
					/>
					<Column
						field='department'
						header='Departmanlar'

						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

							return (
								<div onClick={() => {
									setEditDeveloper({
										open: true,
										isEdit: true,
										developer: {
											...rowData,
											startDate: rowData.startDate,
											developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
										},
									})
								}}
									className={`text-sm cellSetTransparent ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'}`}>
									{rowData?.department?.name}
								</div>
							)
						}}
					/>

					<Column
						header='Aksiyonlar'
						body={(rowData) => {
							const lastMeetDate = moment(rowData.lastMeetDate).format('YYYY-MM-DD')
							const today = moment(new Date(), 'YYYY-MM-DD')
							const isYellow =
								lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -30 && lastMeetDate && moment(lastMeetDate).diff(today, 'days') > -60
							const isRed = lastMeetDate && moment(lastMeetDate).diff(today, 'days') <= -60

							return (
								<span
									className={`projects-list-card-footer-period cellSetTransparent text-sm ${isRed ? 'bg-danger-dark' : isYellow ? 'bg-warning' : 'cellSetTransparent'
										}`}
								>
									{
										<div className='d-flex gap-1'>
											{/* {' '}
											<icons.info
												onClick={() => {
													setEditDeveloper({
														open: true,
														isEdit: false,
														developer: {
															...rowData,
															startDate: rowData.startDate,
															endDate: rowData.endDate,
															lastMeetDate: rowData.lastMeetDate,
															developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
														},
													})
												}}
												color='black'
												className='devs-list-card-settings-icon'
												size={18}
											/>{' '} */}
											{/* <icons.edit
												onClick={() => {
													setEditDeveloper({
														open: true,
														isEdit: true,
														developer: {
															...rowData,
															startDate: rowData.startDate,
															developerSkills: rowData.developerSkills.map((s) => ({ label: s.skills.name, value: s.skills.id })),
														},
													})
												}}
												color='black'
												className='devs-list-card-settings-icon'
												size={18}
											/>{' '} */}
											<icons.delete
												onClick={() => handleDeleteRow(rowData, '/Developer/DeleteDeveloper', 'developers')}
												className='devs-list-card-settings-icon mr-1'
												size={18}
												color='black'
											/>{' '}
										</div>
									}
								</span>
							)
						}}
					/>
				</DataTable>
			)}
			{createDev && (
				<Dialog visible={createDev} onHide={handleCloseModal} draggable={false} blockScroll header='Yeni Çalışan Ekle'>
					<div className='form d-flex flex-column gap-3 mt-2'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<InputText placeholder={'Adı Soyadı'} name='fullName' type='text' onChange={handleChange} className='default-input input-border' />
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<InputText
										name='email'
										placeholder={'Email Adresi'}
										type='email'
										required
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<DefaultSelect
										isMulti={true}
										isFixed
										name='developerSkills'
										placeholder={'Kabiliyetler'}
										selectOptions={skills}
										handleChange={(e) => handleChange(e, 'developerSkills')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<DefaultSelect
										isFixed
										name='developerSkills'
										placeholder={'Çalışma Şekli'}
										selectOptions={[{
											label:'In-House',
											value:0
										},{
											label:'Outsource',
											value:1
										}]}
										handleChange={(e) => handleChange(e, 'inOutSource')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<DefaultSelect
										isFixed
										name='hrId'
										placeholder={'Sorumlu İK'}
										selectOptions={hrUsers}
										handleChange={(e) => handleChange(e, 'hrId')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputText placeholder={'Jira Id'} name='jiraUserId' type='text' onChange={handleChange} className='default-input input-border' />
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<DefaultSelect
										isFixed
										name='companyId'
										placeholder={'Şirket'}
										selectOptions={companies}
										handleChange={(e) => handleChange(e, 'companyId')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<Calendar
										dateFormat='dd/mm/yy'
										placeholder='Başlangıç Tarihi'
										name='startDate'
										onChange={(e) => {
											handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
										}}
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<Calendar
										dateFormat='dd/mm/yy'
										placeholder='Çıkış Tarihi'
										name='endDate'
										onChange={(e) => {
											handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
										}}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-12'>
							<div className='form-control'>
								<DefaultSelect
									isFixed
									name='departmentId'
									placeholder='Departmanlar'
									selectOptions={departments}
									handleChange={(e) => handleChange(e, 'departmentId')}

								/>


							</div>
						</div>
						<div className='col-md-6 offset-md-6'>
							<div className='form-control align-items-end '>
								<Button
									icon={<icons.addUser className='mr-1' size={20} />}
									className='btn-success'
									title='Çalışan Ekle'
									handleClick={() => {
										handleSubmit()
									}}
								/>
							</div>
						</div>
					</div>
				</Dialog>
			)}

			{editDeveloper.open && editDeveloper.isEdit && (
				<Dialog headerStyle={{paddingBottom:'16px', paddingTop:'16px'}} style={{ width: '65vw' }} visible={editDeveloper.open} onHide={handleCloseModal} draggable={false} header={addDevForm?.fullName} >
					<TabView activeIndex={activeIndex} onTabChange={async(e) => {
						setActiveIndex(e.index)
						if (e.index == 2) {
							setLeavesLoading(true)
							await request('/LeaveType/GetAllLeaveTypes', {
								method:'GET'
							}).then(res => {
								console.log(res,'typess')
								if (res?.data?.result?.length > 9) {
									setLeaveTypes(res?.data?.result?.reverse()?.map(t => ({
										label:t.name,
										value:t.id
									})))
								}
							})
							await request('/Developer/GetDeveloperById', {
								method:'GET',
								params:{
									id:addDevForm.id
								}
							}).then(res =>{
								console.log(res,'res')
								setDeveloperById(res?.data?.result)
								setLeaves(res?.data?.result?.leaves?.length > 0 ? res?.data?.result?.leaves?.map(l => ({
									...l,
									totaleave:calculateIzinGun(l.startDate, l.endDate, l.startDayPeriod, l.endDayPeriod)
								})): [])
							})
							setLeavesLoading(false)
						}
						}}>
						<TabPanel header="Bilgiler" leftIcon="pi pi-address-book mr-2">
						<div className='form d-flex flex-column gap-3'>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='text-bold'>Adı Soyadı</label>
									<InputText
										placeholder={'Adı Soyadı'}
										name='fullName'
										type='text'
										value={addDevForm.fullName}
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>

							<div className='col-md-6'>
								<div className='form-control'>
									<label className='text-bold'>Email Adresi</label>
									<InputText
										name='email'
										placeholder={'Email Adresi'}
										type='email'
										value={addDevForm.email}
										required
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='text-bold'>Kabiliyetler</label>
									<DefaultSelect
										isMulti={true}
										isFixed
										name='developerSkills'
										value={addDevForm.developerSkills}
										placeholder={'Kabiliyetler'}
										selectOptions={skills}
										handleChange={(e) => handleChange(e, 'developerSkills')}
									/>
								</div>
							</div>
							<div className='col-md-6 '>
								<div className='form-control'>
									<label className='text-bold'>Departmanlar</label>

									<DefaultSelect
										isFixed
										name='departmentId'
										value={departments.find(c => c.value == addDevForm?.departmentId?.id)}
										placeholder='Departmanlar'
										selectOptions={departments}
										handleChange={(e) => handleChange(e, 'departmentId')}

									/>
								</div>
							</div>

						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='text-bold'>Başlangıç Tarihi</label>
									<Calendar
										dateFormat='dd/mm/yy'
										label='Başlangıç Tarihi'
										placeholder='Başlangıç Tarihi'
										name='startDate'
										value={addDevForm.startDate && new Date(addDevForm.startDate)}
										onChange={(e) => {
											handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
										}}
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<label className='text-bold'>Çıkış Tarihi</label>
									<Calendar
										dateFormat='dd/mm/yy'
										placeholder='Çıkış Tarihi'
										name='endDate'
										value={addDevForm.endDate && new Date(addDevForm.endDate)}
										onChange={(e) => {
											handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
										}}
									/>
								</div>
							</div>
							<div className='col-md-6 mt-3'>
								<div className='form-control'>
									<label className='text-bold'>Çalışma Şekli</label>
									<DefaultSelect
										isFixed
										name='developerSkills'
										placeholder={'Çalışma Şekli'}
										value={[{
											label:'In-House',
											value:0
										},{
											label:'Outsource',
											value:1
										}].find(c => c.value == addDevForm?.inOutSource)}
										selectOptions={[{
											label:'In-House',
											value:0
										},{
											label:'Outsource',
											value:1
										}]}
										handleChange={(e) => handleChange(e, 'inOutSource')}
									/>
								</div>
							</div>
							<div className='col-md-6 mt-3'>
								<div className='form-control'>
									<label className='text-bold'>Sorumlu İK</label>
									<DefaultSelect
										isFixed
										name='developerSkills'
										placeholder={'Sorumlu İK'}
										value={hrUsers.find(c => c.value == (!addDevForm?.hrId?.value ? addDevForm?.hrId : addDevForm?.hrId?.value))}
										selectOptions={hrUsers}
										handleChange={(e) => handleChange(e, 'hrId')}
									/>
								</div>
							</div>
							<div className='col-md-6 mt-3'>
								<div className='form-control'>
									<label className='text-bold'>Jira Id</label>
									<InputText
										placeholder={'Jira Id'}
										name='jiraUserId'
										type='text'
										value={addDevForm.jiraUserId}
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>
							<div className='col-md-6 mt-3'>
								<div className='form-control'>
									<label className='text-bold'>Şirket</label>
									<DefaultSelect
										isFixed
										name='companyId'
										placeholder={'Şirket'}
										value={companies.find(c => c.value == (!addDevForm?.companyId?.value ? addDevForm?.companyId : addDevForm?.companyId?.value))}
										selectOptions={companies}
										handleChange={(e) => handleChange(e, 'companyId')}
									/>
								</div>
							</div>
							{addDevForm.lastMeetDate && (
								<div className='col-md-6 mt-3'>
									<div className='form-control'>
										<label className='text-bold'>Son Görüşme Tarihi</label>
										<Calendar
											dateFormat='dd/mm/yy'
											name='lastMeetDate'
											value={new Date(addDevForm.lastMeetDate)}
											readOnlyInput
											showOnFocus={false}
										/>
									</div>
								</div>
							)}
						</div>
						</div>
						</TabPanel>
						<TabPanel header="Görüşme Notları" leftIcon="pi pi-clipboard mr-2">
					<DataTable
						className='col-md-12 p-0'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						value={evalNotes}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							header='Görüşmeyi Yapan Kişi'
							field='createdUserName'
						/>

						<Column
							field='meetDate'
							header='Görüşme Tarihi'
							body={(rowData) => rowData.meetDate && <span>{moment(rowData.meetDate).format('LL')}</span>}
						/>

						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto' }}
							field='description'
							header='Görüşme Notları'
							body={(rowData) =>
								rowData.description && (
									<span
										// className='scroll-note'
										style={{ maxWidth: '900px', padding: '5px', maxHeight: '100%', display: 'flex', margin: '16px 0px' }}
									>
										{rowData.description}
									</span>
								)
							}
						/>
						<Column
							header='Aksiyonlar'
							body={(rowData) => (
								<div className='d-flex justify-content-center gap-1'>
									<icons.edit
										onClick={() => handleEditClick(rowData)}
										className='devs-list-card-settings-icon cursor-pointer'
										color='black'
										size={18}
									/>
									<icons.delete
										color='black'
										onClick={() => handleDeleteRow(rowData, '/DeveloperEval/DeleteEval', 'notesTable')}
										className='devs-list-card-settings-icon cursor-pointer'
										size={18}
									/>
								</div>
							)}
						/>
					</DataTable>
						</TabPanel>
						<TabPanel header="İzinler" leftIcon="pi pi-list mr-2">
						{
							leavesLoading ? <div className='d-flex w-100 justify-content-center'>
							<Spinner size={3} />
						</div> : <>
						<div className="d-flex flex-column gap-1">
							<div><span className="text-bold">Kalan İzin Hakkı: </span><span>{developerById?.usedAndToBeWonLeave}</span></div>
						</div>
						<DataTable
							className='col-md-12 p-0 mt-3'
							emptyMessage='Hiç Kayıt Bulunamadı'
							size='small'
							responsiveLayout='stack'
							dataKey='id'
							value={leaves}
						>
							<Column
								field='startDate'
								header='Başlangıç Tarihi'
								body={(rowData) => rowData.startDate && <span>{moment(rowData.startDate).format('LL')}</span>}
							/>

							<Column
								field='endDate'
								header='Bitiş Tarihi'
								body={(rowData) => rowData.endDate && <span>{moment(rowData.endDate).format('LL')}</span>}
							/>
							<Column
								headerClassName='text-bold bg-primary text-default'
								className='text-semi-bold text-sm'
								style={{ width: 'auto' }}
								field='totaleave'
								header='Toplam Gün'
							/>
							<Column
								headerClassName='text-bold bg-primary text-default'
								className='text-semi-bold text-sm'
								field='leaveDocuments'
								style={{ width: '14rem' }}
								header='İzin Dokümanları'
								sortable='false'
								body={(rowData) => (
									<ul className='list-style-none word-break'>
										{rowData.leaveDocuments &&
											rowData.leaveDocuments.map((p, i) => (
												<li key={i}>
													<a
														download={p.fileName}
														href={`data:${p.documentType};base64,${p.data}`}
														className='text-primary text-underlined cursor-pointer mr-2'
													>
														{p?.fileName}
													</a>
												</li>
											))}
									</ul>
								)}
							/>
							<Column
								headerClassName='text-bold bg-primary text-default'
								className='text-semi-bold text-sm'
								style={{ width: 'auto' }}
								field='leaveTypeId'
								header='İzin Tipi'
								body={(rowData) =>
									rowData.leaveTypeId && (
										<span
											// className='scroll-note'
											style={{ maxWidth: '900px', padding: '5px', maxHeight: '100%', display: 'flex', margin: '16px 0px' }}
										>
											{leaveTypes.find(t => t.value == rowData.leaveTypeId)?.label}
										</span>
									)
								}
							/>
							<Column
								header='Aksiyonlar'
								body={(rowData) => (
									<div className='d-flex justify-content-center gap-1'>
										<icons.edit
											onClick={() => {
												setFilesData(rowData.leaveDocuments)
												setLeave(rowData)
												setAddLeaveModal(rowData)
											}}
											className='devs-list-card-settings-icon cursor-pointer'
											color='black'
											size={18}
										/>
										<icons.delete
											color='black'
											onClick={() => handleDeleteRow(rowData, '/DeveloperLeave/DeleteLeave', 'leaves')}
											className='devs-list-card-settings-icon cursor-pointer'
											size={18}
										/>
									</div>
								)}
							/>
						</DataTable>
						</>
						}
						
						</TabPanel>
						<TabPanel headerClassName='ml-auto' headerTemplate={() => ( activeIndex == 0 ?
							<Button
							icon={<icons.edit className='mr-1' size={20} />}
							className='btn-success'
							title='Güncelle'
							handleClick={() => {
								handleSubmit()
							}}
						/> : activeIndex == 1 ? <Button
								icon={<icons.report2 className='mr-1' size={20} />}
								className='btn-success'
								title='Görüşme Notu Ekle'
								disabled={getDevelopersLoading}
								handleClick={() => {
									setAddMeetNoteModal(true)
								}}
							/> : activeIndex == 2 ? <Button
								icon={<icons.report2 className='mr-1' size={20} />}
								className='btn-success'
								title='İzin Ekle'
								disabled={getDevelopersLoading}
								handleClick={() => {
									setAddLeaveModal(true)
								}}
							/> : <></>
						)}></TabPanel>
					</TabView>
				</Dialog>
			)}
			{editDeveloper.open && !editDeveloper.isEdit && (
				<Dialog visible={editDeveloper.open} onHide={handleCloseModal} draggable={false} header='Çalışan Detayları'>
					<div className='form d-flex flex-column gap-3 mt-2'>

						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>
										Adı Soyadı: <span>{addDevForm.fullName}</span>
									</label>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>
										Email Adresi: <span>{addDevForm.email}</span>
									</label>
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>İşe Giriş Tarihi: {addDevForm.startDate ? <span>{moment(addDevForm.startDate).format('LL')}</span> : ''}</label>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>İşten Çıkış Tarihi: {addDevForm.endDate ? <span>{moment(addDevForm.endDate).format('LL')}</span> : ''}</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>Son Görüşme Tarihi: {addDevForm.lastMeetDate ? <span>{moment(addDevForm.lastMeetDate).format('LL')}</span> : ''}</label>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<label>Jira User Id: {addDevForm.jiraUserId ? <span>{addDevForm.jiraUserId}</span> : ''}</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label>
										Kabiliyetleri: <span>{addDevForm?.developerSkills?.map((ds) => ds.label)?.join(',')}</span>
									</label>
								</div>
							</div>
						</div>
						<div className='col-md-6 offset-md-6'>
							<div className='form-control align-items-end '>
								<Button
									icon={<icons.edit className='mr-1' size={20} />}
									className='btn-success mb-3'
									title='Görüşme Notu Ekle'
									handleClick={() => evalDevFunc()}
								/>
							</div>
						</div>
					</div>
					<DataTable
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						value={evalNotes}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							header='Görüşmeyi Yapan Kişi'
							field='createdUserName'
						/>

						<Column
							field='meetDate'
							header='Görüşme Tarihi'
							body={(rowData) => rowData.meetDate && <span>{moment(rowData.meetDate).format('LL')}</span>}
						/>

						<Column field='motivationPoint' header='Puan' />

						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto' }}
							field='description'
							header='Görüşme Notları'
							body={(rowData) =>
								rowData.description && (
									<span
										className='scroll-note'
										style={{ maxWidth: '500px', padding: '5px', maxHeight: '200px', overflowY: 'auto', display: 'flex', margin: '16px 0px' }}
									>
										{rowData.description}
									</span>
								)
							}
						/>
						<Column
							header='Aksiyonlar'
							body={(rowData) => (
								<div className='d-flex justify-content-center gap-1'>
									<icons.edit
										onClick={() => handleEditClick(rowData)}
										className='devs-list-card-settings-icon cursor-pointer'
										color='black'
										size={18}
									/>
									<icons.delete
										color='black'
										onClick={() => handleDeleteRow(rowData, '/DeveloperEval/DeleteEval', 'notesTable')}
										className='devs-list-card-settings-icon cursor-pointer'
										size={18}
									/>
								</div>
							)}
						/>
					</DataTable>
				</Dialog>
			)}
			{addMeetNoteModal && (
				<Dialog visible={addMeetNoteModal} onHide={() => setAddMeetNoteModal(false)} draggable={false} header='Çalışan Notu Ekle'>
					<div className='form d-flex flex-column  mt-2'>
						<div className='col-md-12 '>
							<div className='form-control '>
								<div className='form d-flex flex-column  mt-2'>
									<div className='row'>
										<div className='col-md-12'>
											<div className='form-control'>
												<label className='text-bold'>Görüşme Tarihi</label>
												<Calendar
													dateFormat='dd/mm/yy'
													placeholder='Görüşme Tarihi'
													name='meetDate'
													maxDate={maxDate}
													value={evalDevForm?.meetDate && new Date(evalDevForm.meetDate)}
													onChange={(e) => {
														handleChangeEval({ value: moment(e.target.value).add(3, 'hours').toISOString(), name: e.target.name })
													}}
												/>
											</div>
										</div>
									</div>
									<div className='row'>
										<div className='col-md-12'>
											<div className='form-control'>
												<label className='text-bold'>Not</label>
												<InputTextarea
													className='input-border'
													placeholder='Not Giriniz'
													name='description'
													value={evalDevForm?.description}
													onChange={(e) => handleChangeEval(e.target)}
													autoResize={false}
													rows={10}
													cols={80}
												/>
											</div>										</div>

									</div>

									<div className='col-md-6 offset-md-6 mt-2'>
										<div className='form-control align-items-end '>
											<Button
												icon={<icons.report2 className='mr-1' size={20} />}
												className='btn-success'
												title='Görüşme Notu Ekle'
												disabled={getDevelopersLoading}
												handleClick={() => {
													handleEval(false)
												}}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Dialog>
			)}
			{addLeaveModal && (
				<Dialog visible={addLeaveModal} onHide={handleCloseLeaveModal} draggable={false} header='Yeni İzin Bilgisi Ekle'>
					<div className='form d-flex flex-column gap-3 mt-2'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<label className=''>İzin Türü</label>
									<DefaultSelect
										placeholder={"İzin Türü"}
										name='leaveTypeId'
										value={leaveTypes.find(c => c.value === leave.leaveTypeId)}
										selectOptions={leaveTypes}
										handleChange={(e) => handleChnageLeave(e?.value, "leaveTypeId")}
									/>
								</div>
							</div>
						</div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>İzin Başlangıç Tarihi</label>
                                    <Calendar
                                        dateFormat='dd/mm/yy'
										value={leave?.startDate && new Date(leave?.startDate)}
                                        placeholder='İzin Başlangıç Tarihi'
                                        name='startDate'
                                        onChange={(e) => {
                                            handleChnageLeave(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Başlangıç Günü Dönem</label>
                                    <DefaultSelect
                                        placeholder={"Başlangıç Günü Dönem"}
                                        name='startDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === leave.startDayPeriod)}
                                        selectOptions={leaveDayPeriodList}
                                        handleChange={(e) => handleChnageLeave(e?.value, "startDayPeriod")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>İzin Bitiş Tarihi</label>
                                    <Calendar
										value={leave?.endDate && new Date(leave?.endDate)}
                                        dateFormat='dd/mm/yy'
                                        placeholder='İzin Bitiş Tarihi'
                                        name='endDate'
                                        onChange={(e) => {
                                            handleChnageLeave(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-control'>
                                    <label className=''>Bitiş Günü Dönem</label>
                                    <DefaultSelect
                                        placeholder={"Bitiş Günü Dönem"}
                                        name='endDayPeriod'
                                        value={leaveDayPeriodList.find(c => c.value === leave.endDayPeriod)}
                                        selectOptions={leaveDayPeriodList.slice(0, 2)}
                                        handleChange={(e) => handleChnageLeave(e?.value, "endDayPeriod")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-control'>
                                    <label className=''>İzin Yazısı</label>
                                    <InputText
                                        placeholder={'İZİN'}
                                        name='leaveText'
                                        type='text'
                                        value={leave.leaveText}
                                        onChange={handleChnageLeave}
                                        className='default-input input-border'
                                    />
                                </div>
                            </div>
                        </div>
						{
							!leave?.id && <div className='row'>
							<div className='col-md-12'>
								<label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
									<span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>İzin dokümanı yüklemek için tıklayınız</span>
								</label>
								<input
									type='file'
									name='files'
									multiple
									onClick={(e) => e.target.value=null}
									onChange={(e) => handleFiles(e.target)}
									id='file-uploader'
									className='filterTask-file-upload--form--row--item--file-uploader--input'
								/>
							</div>
							<div className='ml-4 w-100 mt-2 gap-3'>
								{filesData?.length > 0 &&
									filesData?.map((file, i) => (
										<div className='text-sm comment-fileList w-unset' key={i}>
											<div className='d-flex align-items-center'>{file?.fileName}</div>
											<Icons.delete
												onClick={() => {
													removeFile(file)
												}}
												size={16}
											/>
										</div>
									))}
							</div>
						</div>
						}
						<div className="row">
							<div className="col-md-12">
								<div className='form-control flex-row gap-2'>
									<Checkbox  id='isReduceLeave' checked={leave.isReduceLeave == 0} onChange={() => setLeave(prev => ({ ...prev, isReduceLeave: prev.isReduceLeave == 0 ? 1 : 0 }))} />
                                    <label htmlFor="isReduceLeave" className="form-control-label">İzin hakkından düşülecek mi?</label>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12"><span className="text-bold">Kalan İzin Hakkı: </span><span>{developerById?.remainingLeave}</span></div>
							<div className="col-md-12"><span className="text-bold">İzin Sonrası Kalan İzin Hakkı: </span><span>{leave.isReduceLeave == 0 ?  Number(developerById?.remainingLeave - calculateIzinGun(leave.startDate, leave.endDate, leave.startDayPeriod, leave.endDayPeriod)) : developerById?.remainingLeave}</span></div>
						</div>
                        <div className='col-md-6 offset-md-6'>
                            <div className='form-control align-items-end '>
                                <Button
                                    icon={leave?.id ? false: <icons.addUser className='mr-1' size={20} />}
                                    className='btn-success'
                                    title={leave?.id ? 'İzin Güncelle' : 'İzin Ekle'}
                                    handleClick={() => {
                                        handleSubmitLeave(addDevForm)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
				</Dialog>
			)}
			{evalDev && (
				<Dialog visible={evalDev} onHide={() => setEvalDev(false)} draggable={false} header='Çalışan Notu Ekle'>
					<div className='form d-flex flex-column gap-3 mt-2'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<Calendar
										dateFormat='dd/mm/yy'
										placeholder='Görüşme Tarihi'
										name='meetDate'
										maxDate={maxDate}
										onChange={(e) => {
											handleChangeEval({ value: moment(e.target.value).add(3, 'hours').toISOString(), name: e.target.name })
										}}
									/>
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-12'>
								<InputTextarea
									className='input-border'
									placeholder='Not Giriniz'
									name='description'
									value={evalDevForm?.description}
									onChange={(e) => handleChangeEval(e.target)}
									autoResize={false}
									rows={10}
									cols={80}
								/>
							</div>
						</div>

						<div className='col-md-6 offset-md-6'>
							<div className='form-control align-items-end '>
								<Button
									icon={<icons.edit className='mr-1' size={20} />}
									className='btn-success'
									title='Çalışan Notu Ekle'
									disabled={getDevelopersLoading}
									handleClick={() => {
										handleEval(false)
									}}
								/>
							</div>
						</div>
					</div>
				</Dialog>
			)}
			{isEvalEdit && (
				<Dialog visible={isEvalEdit} onHide={() => setIsEvalEdit(false)} draggable={false} header='Çalışan Notu Düzenle'>
					<div className='form d-flex flex-column gap-3 mt-2'>
						<div className='row'>
							<div className='col-md-12'>
								<div className='form-control'>
									<Calendar
										dateFormat='dd/mm/yy'
										placeholder='Görüşme Tarihi'
										name='meetDate'
										maxDate={maxDate}
										value={evalDevForm?.meetDate && new Date(evalDevForm.meetDate)}
										onChange={(e) => {
											handleChangeEval({ value: moment(e.target.value).add(3, 'hours').toISOString(), name: e.target.name })
										}}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<InputTextarea
									placeholder='Not Giriniz'
									className='input-border'
									name='description'
									value={evalDevForm.description}
									onChange={(e) => handleChangeEval(e.target)}
									autoResize={false}
									rows={10}
									cols={80}
								/>
							</div>
						</div>

						<div className='col-md-6 offset-md-6'>
							<div className='form-control align-items-end '>
								<Button
									icon={<icons.edit className='mr-1' size={20} />}
									className='btn-success'
									title='Çalışan Notu Düzenle'
									disabled={getDevelopersLoading}
									handleClick={() => {
										handleEval(true)
									}}
								/>
							</div>
						</div>
					</div>
				</Dialog>
			)}

			<Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
				<ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
			</Dialog>
		</AnimatedSpan>
	)
}

Developers.proptypes = {
	createDev: PropTypes.bool,
	setCreateDev: PropTypes.func,
}
export default Developers
